(function () {
  var duration = 1800;

  function showConfirmation(button) {
    if (!button) return;
    var form = button.closest('form');
    var selected = form && form.querySelector('input[name="variant-choice"]:checked');
    var label = button.querySelector('span');
    if (!selected || !label) return;

    window.clearTimeout(button._lussoAddConfirmationTimer);
    if (!button.getAttribute('data-default-label')) button.setAttribute('data-default-label', label.textContent.trim());
    label.textContent = 'Added to cart';
    button.classList.add('is-added');
    button.setAttribute('aria-live', 'polite');
    button._lussoAddConfirmationTimer = window.setTimeout(function () {
      label.textContent = button.getAttribute('data-default-label') || 'Add to cart';
      button.classList.remove('is-added');
    }, duration);
  }

  window.lussoConfirmAdd = showConfirmation;
})();
